const seoIds = {
  sortByFilter: 'sortByFilter',

  pagination: 'pagination-{{key}}',

  vfSeeAll: 'vfSeeAll-{{key}}',
  pdSeeAll: 'pdSeeAll-{{key}}',

  refinedItem: 'refinedItem-{{key}}',
  refineItem: 'refineItem-{{key}}',
  refineItemsGrid: 'refineItemsGrid-{{key}}',
  refineSubItem: 'refineSubItem-{{key}}',

  cardButton: 'cardButton-{{key}}',

  partsAndAccessories: 'part-{{key}}',

  gridLinksHeading: 'gridLinksHeading',
  gridLinksGrid: 'gridLinksGrid',
  gridLink: 'gridLink-{{key}}',

  guidesAndArticles: 'guidesAndArticles-{{key}}',

  article: 'article-{{key}}',

  topSellingParts: 'topSellingParts-{{key}}',

  recentlyViewed: 'recentlyViewed-{{key}}',

  shopByBrand: 'shopByBrand-{{key}}',
  shopByMake: 'shopByMake-{{key}}',

  relatedCategories: 'relatedCategories-{{key}}',

  directFitCheckBox: 'directFitCheckBox',

  showItemsBox: 'showItemsBox-{{key}}',

  sectionCard: 'sectionCard-{{key}}',

  addToCard: 'card-addtocard-{{key}}',
}

export default seoIds
